import { Drawer } from "antd";
import { CampaignScriptPage } from "./Script";

interface CampaignScriptingDrawerProps {
  open: boolean;
  onClose: () => void;
  scriptingId: string;
  refetchInfluencer?: () => void;
  mode?: "default" | "bulkAttach";
  onBack?: () => void;
  onAttach?: () => void;
  isAttaching?: boolean;
  attachCount?: number;
}

export default function CampaignScriptingDrawer({
  open,
  onClose,
  scriptingId,
  refetchInfluencer = () => {},
  mode = "default",
  onBack,
  onAttach,
  isAttaching,
  attachCount,
}: CampaignScriptingDrawerProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={null}
      width={1000}
      closeIcon={false}
      footer={null}
      destroyOnClose
      zIndex={1100}
      styles={{
        header: {
          display: "none",
        },
        body: {
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      {scriptingId ? (
        <CampaignScriptPage
          scriptId={scriptingId}
          onClose={onClose}
          refetchInfluencer={refetchInfluencer}
          mode={mode}
          onBack={onBack}
          onAttach={onAttach}
          isAttaching={isAttaching}
          attachCount={attachCount}
        />
      ) : null}
    </Drawer>
  );
}
